import { Injectable, inject } from "@angular/core";
import {
  State,
  NgxsAfterBootstrap,
  Store,
  Action,
  StateContext,
} from "@ngxs/store";
import { MY_NOTIFICATIONS_LIST_STATE } from "@sdk/lib/values/state-names";
import { filter, switchMap, take, tap } from "rxjs/operators";
import { UpliftNotificationItem } from "@sdk/lib/types/notification";
import { NotificationService } from "@sdk/lib/services/notification.service";
import { FetchMyNotificationsList } from "../actions/notification.actions";
import { APPLICATION_TYPE } from "@sdk/lib/constants/application-types";
import { AuthService } from "@auth0/auth0-angular";

@State<UpliftNotificationItem[]>({
  name: MY_NOTIFICATIONS_LIST_STATE,
  defaults: [],
})
@Injectable({
  providedIn: "root",
})
export class MyNotificationsListState implements NgxsAfterBootstrap {
  private _store = inject(Store);
  private _notificationService = inject(NotificationService);
  private _auth = inject(AuthService);


  ngxsAfterBootstrap() {
    this._auth.isAuthenticated$.pipe(take(1)).subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this._store.dispatch([new FetchMyNotificationsList()]);
      }
    });
  }

  @Action(FetchMyNotificationsList)
  getMyNotificationsList(stateContext: StateContext<UpliftNotificationItem[]>) {
    return this._auth.user$.pipe(
      filter((user) => !!user),
      take(1),
      switchMap((user) =>
        this._notificationService.fetchValidNotifications(
          user.sub,
          APPLICATION_TYPE.USER,
        )
      ),
      tap((notificationsList) => {
        if (Array.isArray(notificationsList)) {
          stateContext.setState([...notificationsList]);
        }
      }),
    );
  }
}
